'use client';

import {useEffect, useState, useCallback} from 'react';
import {date as dateToll} from '@rocket-ui/tools';

export const useTimer = (storageKey: string, duration = 60) => {
	const [seconds, setSeconds] = useState<number>(0);
	const hasSeconds = seconds > 0;
	const minutes = Math.floor(seconds / 60);

	const onReset = useCallback(
		(force = false) => {
			let expireDate = new Date(Number(sessionStorage.getItem(storageKey) || 0));
			if (!expireDate || dateToll.differenceInSeconds(expireDate) < 0 || force) {
				expireDate = dateToll.add.seconds(new Date(), duration);
				sessionStorage.setItem(storageKey, '' + expireDate.getTime());
			}

			setSeconds(dateToll.differenceInSeconds(expireDate));
		},
		[storageKey, duration],
	);

	const onClear = useCallback(() => {
		sessionStorage.removeItem(storageKey);
		setSeconds(0);
	}, [storageKey]);

	useEffect(() => {
		if (!hasSeconds) return;

		const timer = setInterval(() => {
			if (hasSeconds) {
				setSeconds((prevState) => prevState - 1);
			} else {
				clearInterval(timer);
			}
		}, 1000);

		return () => {
			timer && clearInterval(timer);
			onClear();
		};
	}, [hasSeconds, onClear]);

	return {
		onReset,
		onClear,
		seconds,
		hasSeconds,
		result: `${minutes.toString().padStart(2, '0')}:${(seconds - minutes * 60).toString().padStart(2, '0')}`,
	};
};
